import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  ProIntegrationsTermsAndConditionsModel,
  ProIntegrationsTermsAndConditionsResp,
} from '../types/pro-integrations'

export const transformProIntegrationsTermsAndConditionsResponse = (
  response: Response<ProIntegrationsTermsAndConditionsResp>,
): ProIntegrationsTermsAndConditionsModel => ({
  title: response.title,
  body: response.body,
  termsUpdates: response.terms_updates,
})
